import { applyMiddleware, combineReducers, compose, createStore as _createStore, Reducer } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { createSimpleReducer, filtersReducer } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore, TReduxActions } from '../../types/redux';
import { ICurrentRegion } from '../../types/regions';
import { ratingReducer } from '../../../regions/reducers';
import { optionsReducer } from '../../../regions/reducers/options';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers({
    options: optionsReducer,
    filters: filtersReducer,
    rating: ratingReducer,
    regions: createSimpleReducer<ICurrentRegion[] | null>(null),
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  const createStore = (): IReduxStore => _createStore(reducers, initialState, storeEnchancers) as IReduxStore;

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
